import "./header.css";
import mmsImage from '../../assets/Logo.webp';

const Header = () => {
  return (
    <div className="header">
      <div className="art2"></div>
      <div className="headerContainer">
        <img className="imgAppHeader"
          src={mmsImage}
          alt="MMS"
        />
        <div className="headerText">
          <h4>Der Nutri-Score für Medienkonsum</h4>
          <p>Der Mental-Media-Score zeigt dir, wie Worte auf dich wirken können. Auf dein Denken, dein Gefühl und dein Wohlbefinden.</p>
        </div>
        <div className="headerText">
          <h4>Du bist, was du liest.</h4>
          <p>Du siehst hier den Prototypen. Erfahre mehr über das "warum", wie es weitergeht und wer dahintersteckt.</p>
        </div>
      </div>
    </div>
  )
}

export default Header